import posthog from "posthog-js";

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_TOKEN;

if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "/ingest",
    capture_exceptions: true,
    capture_pageview: "history_change",
    capture_pageleave: true,
    defaults: "2026-01-30",
    debug: process.env.NODE_ENV === "development",
    loaded: (client) => client.startSessionRecording(true),
    session_recording: {
      maskAllInputs: true,
    },
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? "https://eu.posthog.com",
  });
} else if (typeof window !== "undefined") {
  console.warn("[posthog] NEXT_PUBLIC_POSTHOG_TOKEN is not set — analytics disabled");
}
